
define('eteration/widgets/ui-img',[
	'knockout',
	'eteration/widgets/widget-util',
    'eteration/eteration-i18n',
    'eteration/eteration'
	], 
	function(ko,widgetUtil,i18n,etr){
	
	

	
	ko.bindingHandlers.img = {
			
			update :  function (element, valueAccessor, allBindingsAccessor) {
				
				var $element = $(element);
				var src = ko.utils.unwrapObservable(valueAccessor().src) || {}; 
				
		
				$element.attr("src",etr.toCDNPATH(src));
					
					
	    		
			}
		};
	
});

